import React from 'react';
import {
  PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';

const PALETTE = [
  '#38bdf8', '#a78bfa', '#fb923c', '#4ade80',
  '#ff4500', '#f472b6', '#facc15', '#34d399',
  '#60a5fa', '#e879f9',
];

// Assign colors: use data.color if present, else cycle through palette
const getColor = (entry, index) =>
  entry.color && entry.color !== '#7b7a88' ? entry.color : PALETTE[index % PALETTE.length];

// Compact custom legend — small dot + truncated name + %
const CustomLegend = ({ payload }) => (
  <ul className="flex flex-col gap-1 mt-2">
    {(payload || []).map((entry, i) => (
      <li key={i} className="flex items-center gap-1.5 min-w-0">
        <span
          className="flex-shrink-0 w-2 h-2 rounded-full"
          style={{ backgroundColor: entry.color }}
        />
        <span
          className="truncate"
          style={{
            fontFamily: 'DM Mono, monospace',
            fontSize: '9px',
            color: '#7b7a88',
            lineHeight: '1.3',
          }}
          title={entry.value}
        >
          {entry.value}
        </span>
      </li>
    ))}
  </ul>
);

// Custom tooltip
const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0];
  return (
    <div
      className="px-3 py-2 rounded-lg border border-[#22222e] bg-[#09090e] text-xs"
      style={{ fontFamily: 'DM Mono, monospace' }}
    >
      <p style={{ color: d.payload.fill || d.color }} className="font-bold mb-0.5">
        {d.name}
      </p>
      <p className="text-white">{d.value}%</p>
      {d.payload.basis && (
        <p className="text-[#7b7a88] text-[10px] mt-0.5 max-w-[160px]">
          {d.payload.basis}
        </p>
      )}
    </div>
  );
};

const PieChartComponent = ({ data = [] }) => {
  if (!data.length) return null;

  // Normalise data — ensure every item has a numeric value
  const chartData = data.map((d, i) => ({
    ...d,
    name:  d.name  || `Item ${i + 1}`,
    value: typeof d.value === 'number' ? d.value : parseFloat(d.value) || 0,
    fill:  getColor(d, i),
  }));

  return (
    <ResponsiveContainer width="100%" height={220}>
      <PieChart>
        <Pie
          data={chartData}
          cx="35%"
          cy="50%"
          innerRadius={55}
          outerRadius={85}
          paddingAngle={2}
          dataKey="value"
          stroke="none"
        >
          {chartData.map((entry, i) => (
            <Cell key={i} fill={entry.fill} />
          ))}
        </Pie>
        <Tooltip content={<CustomTooltip />} />
        <Legend
          layout="vertical"
          align="right"
          verticalAlign="middle"
          iconType="circle"
          iconSize={0}           // hide recharts default icon; we render our own
          content={<CustomLegend />}
          wrapperStyle={{ paddingLeft: '12px', width: '55%' }}
        />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default PieChartComponent;